// src/pages/a6/portfolios/translations.ts

export const fieldTranslations = {
  // Portfolio fields
  client: "Client",
  vehicle: "Véhicule / Bénéficiaire du compte",
  account_name: "Groupe de comptes",
  short_account_name: "Nom court du compte",
  name: "Compte",
  currency: "Devise du portefeuille",
  reporting_currency: "Devise de reporting",
  bank_name: "Banque",
  account_type: "Type de compte",
  investment_type: "Type d'investissement",
  contract_name: "Nom du contrat",

  insurance_company: "Compagnie d’assurance",
  contract_owner: "Titulaire du contrat d’assurance",

  code: "Code",
  strategy_id: "ID de la stratégie",

  has_pdf_bank_page: "Page du compte dans le rapport PDF",
  display_performance_report: "Page de la performance dans le rapport PDF",
  bank_connection: "Connexion bancaire",

  collateral: "Compte-titres nanti",

  // Technical fields
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
